module.exports = __webpack_public_path__ + "static/media/BO6b.70f6ea96.png";